module.exports = __webpack_public_path__ + "9cf51955ba194e4a86205e5f829ef7f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/mobile/abouts-one.png
// module id = 1184
// module chunks = 0